import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCircle,
  faRemove,
  faCog,
  faFilter,
  faSortAlphaDown,
  faSort,
  faSortDown,
  faSortUp,
  faBell,
  faCheck,
  faArrowUp,
  faArrowDown,
  faRefresh,
  faUserGroup,
  faCalendarDays,
  faPlus,
  faGear,
  faBars,
  faMagnifyingGlass,
  faArrowLeft,
  faStar,
  faChevronDown,
  faChevronRight,
  faTimes,
  faArrowRightArrowLeft,
  faList,
  faChartBar,
  faClock,
  faFileInvoiceDollar,
  faTableCellsLarge,
  faTruck,
} from "@fortawesome/free-solid-svg-icons";

import {
  faCalendarDays as faCalendarDays2,
  faCopy,
  faStar as faStarRegular,
} from "@fortawesome/free-regular-svg-icons";
import { IconProp, SizeProp } from "@fortawesome/fontawesome-svg-core";
import React from "react";

library.add(
  faCircle,
  faRemove,
  faCog,
  faFilter,
  faSortAlphaDown,
  faSort,
  faSortDown,
  faSortUp,
  faCalendarDays,
  faBell,
  faCheck,
  faArrowUp,
  faArrowDown,
  faRefresh,
  faUserGroup,
  faCopy,
  faCalendarDays2,
  faPlus,
  faGear,
  faBars,
  faMagnifyingGlass,
  faArrowLeft,
  faStar,
  faStarRegular,
  faChevronDown,
  faChevronRight,
  faTimes,
  faArrowRightArrowLeft,
  faList,
  faChartBar,
  faClock,
  faFileInvoiceDollar,
  faTableCellsLarge,
  faTruck
);

interface AwesomeIconProps {
  icon: IconProp;
  size?: SizeProp;
  color?: string;
  title?: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: (event: React.MouseEvent<HTMLSpanElement>) => void;
  children?: React.ReactNode;
}

/** https://fontawesome.com/v5/docs/web/use-with/react */
const AwesomeIcon: React.FC<AwesomeIconProps> = ({
  icon,
  size,
  color,
  title,
  className = "",
  style,
  onClick,
  children,
}) => {
  if (!icon) {
    return null;
  }

  return (
    <span
      onClick={onClick}
      title={title}
      className={`fa-icon ${className}`}
      style={style}
      role={onClick ? "button" : undefined}
    >
      <FontAwesomeIcon
        size={size}
        icon={icon}
        color={color}
        style={{ position: "unset" }}
      />
      {children}
    </span>
  );
};

export default AwesomeIcon;
